import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-dc-selector-card',
    templateUrl: './dc-selector-card.component.html',
    styleUrls: ['./dc-selector-card.component.scss'],
    standalone: false
})
export class DcSelectorCardComponent implements OnInit {
  @Input() value: string;
  @Input() requestType: string;
  @Input() cardColour: string;

  viewHoverText = false;
  constructor() {}

  ngOnInit(): void {}
}
